export const _setFolderPath = (state, action) => {
  state.folderPath = [...state.folderPath, action.payload];
};

export const _resetFolderPath = (state, action) => {
  state.folderPath = action.payload;
};
